import styled from 'styled-components';

import { Loader, LoaderSize } from '@dreryk/react-components';

const StyledPageLoader = styled.div`
   height: 100%;
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
`;

StyledPageLoader.displayName = 'StyledPageLoader';

// TODO: https://dreryk.atlassian.net/browse/DREGAB-2508 - Reusable styled loader
export const PageLoader = (): JSX.Element => (
   <StyledPageLoader>
      <Loader size={LoaderSize.BIG} testId={'pageLoader'} />
   </StyledPageLoader>
);
